import { render } from "./Tuiguang.vue?vue&type=template&id=2006d9cd&scoped=true"
import script from "./Tuiguang.vue?vue&type=script&lang=js"
export * from "./Tuiguang.vue?vue&type=script&lang=js"

import "./Tuiguang.vue?vue&type=style&index=0&id=2006d9cd&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2006d9cd"]])

export default __exports__